import { Injectable } from '@angular/core';
import { CURRENT_ENV, API_GATEWAY_BASE_URLS, GOOGLE_MAPS_API_KEY } from './env-config';

@Injectable({ providedIn: 'root' })
export class AppConfigService {
  private readonly env = CURRENT_ENV;
  private readonly apiGatewayBaseUrl = API_GATEWAY_BASE_URLS[this.env];

  getEnv(): string {
    return this.env;
  }

  getApiGatewayBaseUrl(): string {
    return this.apiGatewayBaseUrl;
  }

  /** Gateway proxies /ws-hubs/support-chat to auth-api SignalR hub. */
  getSupportHubBaseUrl(): string {
    return this.apiGatewayBaseUrl;
  }

  getGoogleMapsApiKey(): string {
    return GOOGLE_MAPS_API_KEY;
  }
}
